import React from 'react'
import injectSheet from 'react-jss'
import styles from './info-modal.styles'
import { Modal, ModalContent } from 'pobble-components/dist/modal'

const InfoModal = ({ classes, icon, children, ...props }) => {
  return (
    <Modal closeButton {...props}>
      <ModalContent className={classes.content}>
        {!!icon && <div className={classes.icon}>{icon}</div>}
        {children}
      </ModalContent>
    </Modal>
  )
}

export default injectSheet(styles)(InfoModal)
